import React from 'react'
import { EditPage } from '@equipedigitalfloripa/ed-cms/components'
import * as gestaoApi from '../api/gestao'

const EditGestao = ({ edit }) => {

    const selectedData = [
        {
            name: '_id',
            type: 'hidden',
            title: 'Id'
        },
        {
            name: 'name',
            type: 'text',
            title: "Nome",
            validation: {
                required: true
            }
        }
    ]
    return (
        <EditPage 
            selectedData={selectedData} 
            addFunction={gestaoApi.addItem} 
            fetchFunction={gestaoApi.fetchItem} 
            editFunction={gestaoApi.editItem} 
            edit={edit} 
            url='gestao' 
        />
    )
}

export default EditGestao
